<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Generate Access Code'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (state === 'loading') {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }

    @if (state === 'empty') {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'You don\'t have any smart locks connected yet.'" />
        </tidy-row>
      </tidy-alert>
      <tidy-button
        [text]="'Connect Smart Locks'"
        [action]="goToConnectLocks"
        class="primary" />
    }

    @if (state === 'ready') {
      <tidy-row>
        <tidy-text
          [body]="'Generate a code that works on this lock from now until it expires. Use it to test the lock or give it to someone. It is not added to any reservation or guidebook.'" />
      </tidy-row>

      <form [formGroup]="deviceForm" novalidate action="#">
        <tidy-select
          [label]="'Smart Lock'"
          [icon]="'assets/svg/lock-closed-outline.svg'"
          [form]="deviceForm.controls.deviceId"
          formControlName="deviceId"
          [items]="deviceOptions"
          (optionChange)="onDeviceChange()" />
        <tidy-select
          [label]="'Expires after'"
          [icon]="'assets/svg/time-outline.svg'"
          [form]="deviceForm.controls.expirationHours"
          formControlName="expirationHours"
          [items]="expirationOptions" />
      </form>

      <tidy-row class="align-right">
        <tidy-button
          [text]="'Generate Code'"
          [action]="generateCode"
          class="primary" />
      </tidy-row>
    }

    @if (state === 'generating') {
      <div class="loading-container">
        <tidy-loader />
        <tidy-row [align]="'center'">
          <tidy-text [body]="'Generating your code...'" />
        </tidy-row>
      </div>
    }

    @if (state === 'result') {
      <tidy-card>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/checkmark-circle-outline.svg'"
            class="body-size" />
          <tidy-text [header]="'Code Ready'" />
        </tidy-row>
        @if (selectedDeviceLabel) {
          <tidy-row>
            <tidy-text [helper]="selectedDeviceLabel" [translate]="false" />
          </tidy-row>
        }
        <tidy-row [align]="'center'" class="test-code-row">
          <tidy-text
            class="test-code-value"
            [title]="generatedCode?.code"
            [translate]="false" />
        </tidy-row>
        @if (validRangeText) {
          <tidy-row [align]="'center'">
            <tidy-text
              [helper]="validRangeText"
              [translate]="false" />
          </tidy-row>
        }
      </tidy-card>

      <tidy-row class="align-right result-actions">
        <tidy-button
          [text]="'Copy Code'"
          [action]="copyCode"
          class="secondary" />
        <tidy-button
          [text]="'Generate New Code'"
          [action]="generateCode"
          class="primary" />
      </tidy-row>
    }

    @if (state === 'error') {
      <tidy-error-message [text]="errorMessage" />
      <tidy-button
        [text]="'Try Again'"
        [action]="retry"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
